import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../../api';
import api from '../../../../api/endpoints';

const prepareDataTable = data => {
  const dataTable = [];

  data.forEach(item => {
    const el = {
      key: item.id,
      id: item.id,
      name: item.name,
      type: item.type,
      total_users: item.total_users,
      operations: { id: item.id, type: 'user', name: item.name }
    };
    dataTable.push(el);
  });

  return dataTable;
};

function* getRegularusersGroups({ payload: { signal, curr_page, searchQ } }) {
  try {
    const { data } = yield call(fetch, {
      api: api.modifiers.regularusers.list,
      params: { page: curr_page, q: searchQ },
      signal
    });

    const preparedData = {
      dataTable: prepareDataTable(data.results),
      message: data.message,
      count: data.count,
      next: data.next,
      previous: data.next
    };

    yield put(actions.getRegularusersGroupsDone(preparedData));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getRegularusersGroupsFailed,
      endpoint: api.modifiers.regularusers.list.url
    });
  }
}

export const getRegularusersGroupsSaga = takeEvery(types.GET_REGULARUSERS_GROUPS_REQUEST, getRegularusersGroups);